import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useContactDialog } from "../common";
import { colors, spacing, typography, borderRadius } from "../../theme/tokens";

export const ContactBannerSection: React.FC = () => {
  const { open: openContactDialog } = useContactDialog();

  return (
    <Box
      sx={{
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
        background: colors.brand.gradient.primary,
        px: { xs: "16px", md: "10vw" },
        py: spacing[1000],
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: spacing[600],
        flexWrap: "wrap",
      }}
    >
      <Typography
        sx={{
          color: colors.neutral[0],
          fontSize: typography.fontSize.xl,
          fontWeight: typography.fontWeight.bold,
        }}
      >
        Webシステム開発・デザインのご相談、お気軽にどうぞ。
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={openContactDialog}
        sx={{
          backgroundColor: colors.accent.amber,
          color: colors.neutral[0],
          px: spacing[800],
          py: spacing[300],
          fontSize: typography.fontSize.base,
          fontWeight: typography.fontWeight.bold,
          borderRadius: borderRadius.full,
          "&:hover": {
            backgroundColor: "#d97706",
          },
        }}
      >
        お問い合わせはこちら →
      </Button>
    </Box>
  );
};
